// The one page frame every screen in this app renders inside. Per
// portal/CLAUDE.md ("DESKTOP FIRST at 1366x768... give every page the site
// header and footer"), the shell now renders the SAME SiteHeader +
// SiteFooter the landing page uses, on every screen — not the old slim bar.
// SiteHeader's "Contact" link is an in-page #contact anchor that resolves to
// SiteFooter, so the two must always render together; putting both here
// gives every page that for free.
//
// `width` picks the content column cap: "narrow" (~440px, single-field
// forms), "medium" (~780px, content pages, the default) or "wide" (~1180px,
// grids and tables). The old `wide` boolean still works — it maps to
// width="wide" — so the ~6 existing call sites keep functioning while they
// migrate.
//
// `backTo`/`backLabelId` are optional — most of this app's screens are a
// forward-only flow (landing → guest/login → ... → confirmation), and a
// stray back link on every screen would just invite a guest to lose typed
// progress by accident. When passed, the back link renders as a breadcrumb
// row BELOW the header, never instead of it.

import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext.jsx';
import SiteHeader from './SiteHeader.jsx';
import SiteFooter from './SiteFooter.jsx';
import styles from './PortalShell.module.css';

export default function PortalShell({ backTo, backLabelId, width, wide, children }) {
  const { t } = useLanguage();
  const resolvedWidth = wide ? 'wide' : width || 'medium';

  return (
    <div className={styles.shell}>
      <SiteHeader />

      <main className={`${styles.main} ${styles[resolvedWidth]}`}>
        <div className={styles.content}>
          {backTo && (
            <nav className={styles.breadcrumb}>
              <Link to={backTo} className={styles.backLink}>
                {t(backLabelId || 'portal.login.backToLanding')}
              </Link>
            </nav>
          )}
          {children}
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}
